import { type IntlShape } from 'react-intl';

import { type PartnerValidity } from 'components/PartnerDetailsModal/types';
import messages from 'containers/StatusLabels/messages';

// Formats the reading a `partner_label` entry's `validity` produces — no more, no less.
export const validityText = (
  validity: PartnerValidity | undefined,
  intl: IntlShape,
): string | undefined => {
  // A reading that predates the counter carries no number, and a plural that loses its value renders its own pattern.
  if (validity?.state === 'valid') {
    return typeof validity.days_remaining === 'number'
      ? intl.formatMessage(messages.bgcValid, {
          count: validity.days_remaining,
          date: validity.date,
        })
      : undefined;
  }
  if (validity?.state === 'expired') {
    return intl.formatMessage(messages.bgcExpired, { date: validity.date });
  }

  return undefined;
};
